// Front
// import LayoutReducer from "./layouts/reducer";
import EcommerenceReducer from "./e-commerence/reducer";
import CryptoReducer from "./crypto/reducer";
import InvoiceReducer from "./invoices/reducer";
import ProjectsReducer from "./projects/reducer";
import TasksReducer from "./tasks/reducer";
import ContactsReducer from "./contacts/reducer";
import DashboardReducer from "./dashboards/reducer";
import JobsReducer from "./jobs/reducer";
import ChatsReducer from "./chats/reducer";
import CalendarReducer from "./calendar/reducer";
import LayoutReducer from "./layouts/reducer";
import EmailReducer from "./email/reducer";
import LoginReducer from "./auth/login/reducer";
import ProfileReducer from "./auth/profile/reducer";
import ForgotPasswordReducer from "./auth/forgetpwd/reducer";
import AccountReducer from "./auth/register/reducer";
import CartReducer from "./cart/reducer";
import paymentReducer from "./payment/reducer";
import BranchReducer from "./branch/reducer";
import OrdersReducer from "./orders/reducer";

import storage from "redux-persist/lib/storage";
import { persistStore, persistReducer } from "redux-persist";
import { combineReducers, configureStore } from "@reduxjs/toolkit";
const persistConfig = {
  key: "root",
  storage,
};

const rootReducers = combineReducers({
  Layout: LayoutReducer,
  ecommerce: EcommerenceReducer,
  crypto: CryptoReducer,
  invoices: InvoiceReducer,
  projects: ProjectsReducer,
  tasks: TasksReducer,
  contacts: ContactsReducer,
  dashboard: DashboardReducer,
  jobs: JobsReducer,
  chats: ChatsReducer,
  calendar: CalendarReducer,
  email: EmailReducer,
  Login: LoginReducer,
  Profile: ProfileReducer,
  ForgetPassword: ForgotPasswordReducer,
  Account: AccountReducer,
  payment: paymentReducer,
  cart: CartReducer,
  branch: BranchReducer,
  orders: OrdersReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducers);

const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredPaths: ["register"],
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
});
export const persistor = persistStore(store);

export type RootState = ReturnType<typeof rootReducers>;

export default store;
